import { SVGProps } from 'react';

const Plug2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 2v6m6-6v6m-3 9v5m0-5a6 6 0 0 0 6-6V8H6v3a6 6 0 0 0 6 6M5 8h14"
    />
  </svg>
);
export default Plug2;
